<template>
  <div class="question-input-container">
    <v-textarea
      class="question-input-text-area"
      :placeholder="placeholder"
      v-model="question"
      hide-details
      dense
      light
      no-resize
      height="80px"
      rows="2"
      solo
      flat
      @keydown="onEnterPress"
    ></v-textarea>
    <v-btn
      class="question-input-send-button-container"
      icon
      color="secondary"
      :aria-label="sendButtonAriaLabel"
      @click="sendQuestion"
      @keydown="
        (e) => (e.key === 'Enter' || e.key === ' ' ? sendQuestion() : null)
      "
    >
      <v-icon
        v-if="sendQuestionDisabled"
        class="question-input-send-button-disabled"
        :alt="sendButtonAriaLabel"
        >mdi-send-outline</v-icon
      >
      <v-icon
        v-else
        class="question-input-send-button"
        :alt="sendButtonAriaLabel"
        >mdi-send</v-icon
      >
    </v-btn>
    <div class="question-input-bottom-border"></div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'QuestionInput',
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: '',
    },
    conversationId: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      question: '',
    }
  },
  computed: {
    sendQuestionDisabled() {
      return this.disabled || !this.question.trim()
    },
    sendButtonAriaLabel() {
      return this.$t('aiChat.sendButtonAriaLabel')
    },
  },
  methods: {
    sendQuestion() {
      if (this.disabled || !this.question.trim()) {
        return
      }

      if (this.conversationId) {
        this.onSend(this.question, this.conversationId)
      } else {
        this.onSend(this.question)
      }
      this.question = ''
    },
    onSend(question: string, conversationId?: string) {
      this.$emit('send', { question, conversationId })
    },
    onEnterPress(ev) {
      if (ev.key === 'Enter' && !ev.shiftKey && !(ev.isComposing === true)) {
        ev.preventDefault()
        this.sendQuestion()
      }
    },
  },
})
</script>

<style lang="scss">
.question-input-container {
  height: 120px;
  position: absolute;
  left: 0%;
  right: 0%;
  top: 0%;
  bottom: 0%;
  background: #ffffff;
  box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.14), 0px 0px 2px rgba(0, 0, 0, 0.12);
  border-radius: 8px;
  .v-textarea textarea {
    line-height: 1.5rem;
    font-size: 14px;
  }
}

.question-input-text-area {
  width: 100%;
  line-height: 40px;
  margin-top: 10px;
  margin-bottom: 10px;
}

.question-input-send-button-container {
  position: absolute;
  right: 24px;
  bottom: 15px;
  cursor: pointer;
}

.question-input-send-button {
  width: 24px;
  height: 23px;
  background: radial-gradient(
    106.04% 106.06% at 100.1% 90.19%,
    #0f6cbd 33.63%,
    #8dddd8 100%
  );
  background-clip: text;
  -webkit-text-fill-color: transparent;
}

.question-input-send-button-disabled {
  width: 24px;
  height: 23px;
  color: rgba(66, 66, 66, 0.4) !important;
}

.question-input-bottom-border {
  position: absolute;
  width: 100%;
  height: 4px;
  left: 0%;
  bottom: 0%;
  background: radial-gradient(
    106.04% 106.06% at 100.1% 90.19%,
    #0f6cbd 33.63%,
    #8dddd8 100%
  );
  border-bottom-left-radius: 8px;
}

.question-input-options-button {
  cursor: pointer;
  width: 27px;
  height: 30px;
}

@media (max-width: 480px) {
  .question-input-container {
    left: 0%;
  }
}
</style>
